import { useCallback, useLayoutEffect, useRef } from 'react'
import { i18n } from '@fs/zion-locale'
import { useStatusOverlay } from '@fs/zion-ui'
import { ValidationError } from '../errors'
import noticeError from '../services/noticeError'

function formatErrorMessage(error) {
  if (error instanceof ValidationError) {
    const message = error.render()
    if (message && typeof message === 'string') {
      // only strings can be rendered in status overlay
      return message
    }
  }
  return i18n.t('generic.error', 'Something went wrong, try again later')
}

export default function useErrorReporter() {
  const showStatusOverlay = useStatusOverlay()
  // useRef with useLayoutEffect to avoid returning a new reportError function
  // on every render. This way we don't have to depend on useStatusOverlay's
  // implementation. Recipe from: https://epicreact.dev/how-react-uses-closures-to-avoid-bugs
  const showStatusOverlayRef = useRef(showStatusOverlay)
  useLayoutEffect(() => {
    showStatusOverlayRef.current = showStatusOverlay
  })
  return useCallback(function reportError(error) {
    const message = formatErrorMessage(error)
    showStatusOverlayRef.current({
      message,
      type: 'error',
    })
    noticeError(error)
  }, [])
}
